/* JadeAudio front-end effects: scroll reveal + product badges.
   Lightweight, no dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll reveal ---------- */
  function setupReveal() {
    if (reduce) return;
    if (!('IntersectionObserver' in window)) return; // CSS keeps everything visible

    // Target the main content sections (not header/footer)
    var selectors = [
      '.featured-collection',
      '.collection',
      '.multicolumn',
      '.rich-text',
      '.image-with-text',
      '.collection-list',
      '.section-product-tabs'
    ];
    var nodes = [];
    selectors.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { nodes.push(el); });
    });
    if (!nodes.length) return;

    // Enable the hide-then-reveal styling only now that JS is running
    document.documentElement.classList.add('ja-js');

    var reveal = function (el) {
      el.classList.add('ja-in');
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          reveal(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    nodes.forEach(function (n) {
      n.classList.add('ja-reveal');
      // Anything already in (or above) the viewport on load: reveal immediately
      var rect = n.getBoundingClientRect();
      if (rect.top < (window.innerHeight || document.documentElement.clientHeight) * 0.95) {
        reveal(n);
      } else {
        io.observe(n);
      }
    });

    // Absolute fail-safe: after 1.5s, reveal anything still hidden
    setTimeout(function () {
      nodes.forEach(reveal);
    }, 1500);
  }

  /* ---------- 2. Product badges from tags ---------- */
  function setupBadges() {
    document.querySelectorAll('.card-wrapper').forEach(function (wrap) {
      var media = wrap.querySelector('.card__media');
      if (!media || media.querySelector('.ja-badge')) return;

      // Read tags exposed via data attribute (added in card snippet)
      var tagsAttr = (wrap.getAttribute('data-ja-tags') || '').toLowerCase();
      // A product is on sale ONLY if the price block carries the on-sale class
      // (the .price__sale node always exists in Dawn, so don't test for it).
      var priceEl = wrap.querySelector('.price');
      var onSale = priceEl && priceEl.classList.contains('price--on-sale');

      var badge = null;
      if (onSale) {
        badge = makeBadge('Sale', 'sale');
      } else if (/(^|,)\s*new(\s|,|$)/.test(tagsAttr)) {
        badge = makeBadge('New', 'new');
      } else if (/(^|,)\s*featured(\s|,|$)/.test(tagsAttr)) {
        badge = makeBadge('Featured', 'featured');
      }
      if (badge) media.appendChild(badge);
    });
  }

  function makeBadge(text, kind) {
    var b = document.createElement('span');
    b.className = 'ja-badge ja-badge--' + kind;
    b.textContent = text;
    return b;
  }

  function init() {
    setupReveal();
    setupBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
